<template>
<div class="chapter">
<div class="inner_page">
<div id="fm3">
<a id="pageii">
<p class="play"><span>Plays by John Guare</span></p>
<p class="play1"><em class="italic">Bosoms and Neglect</em></p>
<p class="play2"><em class="italic">Chaucer in Rome</em></p>
<p class="play2"><em class="italic">Cop-Out</em></p>
<p class="play2"><em class="italic">A Few Stout Individuals</em></p>
<p class="play2"><em class="italic">Four Baboons Adoring the Sun</em></p>
<p class="play2"><em class="italic">A Free Man of Color</em></p>
<p class="play2"><em class="italic">General of Hot Desire</em></p>
<p class="play2"><span><em class="italic">His Girl Friday</em> (<em class="italic">adaptation</em>)</span></p>
<p class="play2"><em class="italic">Home Fires</em></p>
<p class="play2"><em class="italic">House of Blue Leaves</em></p>
<p class="play2"><em class="italic">Lake Hollywood</em></p>
<p class="play2"><em class="italic">Landscape of the Body</em></p>
<p class="play2"><em class="italic">Lydie Breeze:</em></p>
<p class="play2"><em class="italic">Part One: Women and Water</em></p>
<p class="play2"><em class="italic">Part Two: Bulfinch’s Mythology</em></p>
<p class="play2"><em class="italic">Part Three: The Sacredness of the Next Task</em></p>
<p class="play2"><em class="italic">Marco Polo Sings a Solo</em></p>
<p class="play2"><em class="italic">Moon Under Miami</em></p>
<p class="play2"><em class="italic">Muzeeka</em></p>
<p class="play2"><em class="italic">Rich and Famous</em></p>
<p class="play2"><em class="italic">Six Degrees of Separation</em></p>
</a></div><a id="pageii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780802195005_plays_by_john_guare.vue?6d9f5b60